/*=========================================================================================
  File Name: module-usertax-mutations.js
  Description: UserTax Module Mutations
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
/**
 * state mặc định của module
 */
import defaultState from './module-user-state';

export default {
	/**
	 * Reset lại trạng thái của state
	 * @param {State} state
	 */
	resetState(state) {
		Object.assign(state, defaultState);
	},
	/**
	 * Chỉ clear dữ liệu danh sách người dùng (list + phân trang).
	 * Dùng khi rời màn Quản lý người dùng — giữ nguyên các thông tin khác
	 * của module user như user hiện tại, Role, userConfig, WorkPermission,
	 * JobTitles, MWSTokenV2.
	 * @param {State} state
	 */
	resetUserList(state) {
		state.UserList.removeAll();
		state.Total = 0;
	},
	updateUserList(state, res) {
		state.UserList.removeAll();
		state.UserList.append(res.Data.Data);
	},
	deleteUser(state, item) {
		state.UserList.remove(item);
		state.Total -= 1;
	},
	addNew(state, item) {
		state.UserList.push(item);
	},
	updateUserListLoaded(state, data) {
		state.userListLoaded = data;
	},
	updateRole(state, data) {
		state.Role = data.Role;
	},
	updateUser(state, data) {
		state.user = data;
	},
	updateGuide(state, data) {
		if (state.user) {
			state.user.IsViewGuide = data;
		}
	},
	updateGuideV2(state, data) {
		if (state.user) {
			state.user.ViewGuideLiveChatStatus = data;
		}
	},

	updateNewVersion(state, val) {
		if (state.user) {
			if (val) {
				state.user.Version = val;
				state.user.IsNewVersion = false;
			}
		}
	},

	updateWatchedToolbarGuide(state, val) {
		if (state.user) {
			state.user.IsWatchedToolbarGuide = val;
			state.user.IsWatchedToolbarGuideStep3 = val;
		}
	},

	updateWatchedToolbarGuideStep3(state, val) {
		if (state.user) {
			state.user.IsWatchedToolbarGuideStep3 = val;
		}
	},

	//Created by pddang 22/09/2026 - Lưu trạng thái đã chọn "Không hiển thị lại" popup rút ngắn mẫu mặc định (PBI 677171)
	updateWatchedShortenTemplateGuide(state, val) {
		if (state.user) {
			state.user.IsWatchedShortenTemplateGuide = val;
		}
	},

	updateWatchedInvoiceInputGuide(state, val) {
		if (state.user) {
			state.user.IsWatchedInvoiceInputGuide = val;
		}
	},

	updateWorkPermission(state, data) {
		state.WorkPermission.removeAll();
		state.WorkPermission.append(data.Permissions);
	},

	updateTitles(state, res) {
		state.JobTitles.removeAll();
		state.JobTitles.append(res);
	},

	updateShowNotify(state, res) {
		state.user.IsShowNotify = res;
	},

	updateViewInvoiceDetail(state, res) {
		state.user.ViewInvoiceDetail = res;
	},

	updateViewCheckingResult(state, res) {
		//Không cập nhật vào state những dữ liệu không hợp lệ
		if (!res && res != 0) return;
		state.user.ViewCheckingResult = res;
	},

	updateTotalPage(state, res) {
		state.Total = res || 0;
	},

	updateLoadingTotalRecords(state, res) {
		state.IsLoadingTotalRecords = res;
	},

	updateCheckServeyUser(state, data) {
		state.CheckServeyUser = data;
	},

	updateShowAvaAdv(state, res) {
		state.user.IsShowAvaChatbot = res;
	},

	updateMWSToken(state, res) {
		if (!res || res.ExpiredDate || res.Token) return;
		state.MWSTokenV2.ExpiredDate = res.ExpiredDate;
		state.MWSTokenV2.Token = res.Token;
	},

	updateStateUserConfig(state, res) {
		state.userConfig = res;
	},

	updateStateIsNewConfig(state, res) {
		state.userConfig.VersionFeatureConfig = { ...state.userConfig.VersionFeatureConfig, ...res };
	},

	updateViewedFilm(state, res) {
		state.userConfig.ViewedVideoIds = [...res];
	},

	updateShowUnclassifiedCost(state, res) {
		state.userConfig.ShowUnclassifiedCostInReport = res;
	},

	updateFeatureTooltipConfig(state, res) {
		//Chỉ dữ lại 1 tooltip của vòng gần nhất thôi
		state.featureTooltipConfig = res;
	}
};
